/* eslint-disable dot-notation */
import Title from 'components/Title';
import { useMainContext } from 'context/MainContext';
import { ISalesChannel } from 'interfaces/ISalesChannel';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserService } from 'services/userService';
import { useSalesChannelService } from 'services/salesChannelService';
import { IUser } from 'interfaces/IUser';
import { Container } from './styles';

const AddEditSalesChannel: React.FC = () => {
  const salechannel = useLocation().state as ISalesChannel;
  const navigate = useNavigate();
  const { setDialog } = useMainContext();
  const { salesChannelService } = useSalesChannelService();
  const { userService } = useUserService();
  const [validated, setValidated] = useState(false);
  const [salesChannelAddEdit, setSalesChannelAddEdit] = useState<ISalesChannel>(
    {
      Name: '',
      AdminUserId: '',
      MaxDiscount: 0,
      CreatedDate: new Date()
    } as ISalesChannel
  );
  const [users, setUsers] = useState<IUser[] | null>(null);

  const handleConfirm = useCallback(async () => {
    try {
      if (salechannel?.SalesChannelId)
        await salesChannelService.update(salesChannelAddEdit);
      else await salesChannelService.add(salesChannelAddEdit);
      navigate(-1);
    } catch (error) {
      console.log(
        `error in AddEditUser - function handleConfirm, error:${error}`
      );
    }
  }, [
    navigate,
    salechannel?.SalesChannelId,
    salesChannelAddEdit,
    salesChannelService
  ]);

  const handleSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      const form = event.currentTarget;

      event.preventDefault();
      event.stopPropagation();
      setValidated(!form.checkValidity());

      if (form.checkValidity())
        setDialog({ show: true, callBackConfirm: handleConfirm });
    },
    [handleConfirm, setDialog]
  );

  const getData = useCallback(async () => {
    try {
      const userResult = await userService.getByGroupRuleId(
        'D0FCD45D-12F7-4588-B5F8-FB63A5A0A1F0'
      );
      setUsers(userResult);
    } catch (error) {
      console.log(`error in AddEditUser - function getData, error:${error}`);
    }
  }, [userService]);

  useEffect(() => {
    if (salechannel?.SalesChannelId) {
      setSalesChannelAddEdit(salechannel);
    }
    getData();
  }, [getData, salechannel]);

  return (
    <Container>
      <Title backButton>
        {' '}
        {salechannel?.SalesChannelId ? 'Editar' : 'Adicionar'} Canal de Venda{' '}
      </Title>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Form.Group as={Col} sm={12} md={6} controlId="validationName">
            <Form.Label>Nome</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder="Nome"
              defaultValue={salesChannelAddEdit.Name}
              onChange={e =>
                setSalesChannelAddEdit(prevState => ({
                  ...prevState,
                  Name: e.target.value
                }))
              }
            />
            <small>*campo opcional</small>
          </Form.Group>
          <Form.Group as={Col} sm={12} md={6} controlId="validationadminUserId">
            <Form.Label>Responsável</Form.Label>
            <Form.Select
              name="adminUserId"
              required
              value={salesChannelAddEdit.AdminUserId}
              onChange={e =>
                setSalesChannelAddEdit(prevState => ({
                  ...prevState,
                  AdminUserId: String(e.target.value)
                }))
              }
            >
              <option value={0}>Selecione um usuário</option>
              {users &&
                users.map(user => (
                  <option key={user.Id} value={user.Id}>
                    {user.Name}
                  </option>
                ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              Campo Obrigatório
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
        <Row className="mb-3">
          <Form.Group as={Col} sm={12} md={6} controlId="validationmaxDiscount">
            <Form.Label>Desconto Máximo</Form.Label>
            <Form.Control
              type="number"
              name="maxDiscount"
              placeholder="0"
              required
              value={salesChannelAddEdit.MaxDiscount}
              onChange={e =>
                setSalesChannelAddEdit(prevState => ({
                  ...prevState,
                  MaxDiscount: Number(e.target.value)
                }))
              }
            />
          </Form.Group>
        </Row>

        <hr />
        <Button variant="primary" type="submit">
          Salvar
        </Button>
      </Form>
    </Container>
  );
};

export default AddEditSalesChannel;
